import { NavLink } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useStore } from '@context/store'
import { fetchKeywords } from '@services/wpApi'
import { SERVICE_SUMMARY } from '../../constants'
import HeroGuy from '@assets/img/image-guy.png'

const Keywords = () => {
  const { serviceName } = useStore();

  const { data, isLoading } = useQuery(['keywords', serviceName], () => fetchKeywords(serviceName));

  return (
    <div className='container px-4'>
      <div className="py-8 pb-8 px-4 bg-secondary mb-6 rounded-lg relative overflow-hidden">
        <div className="absolute bottom-0 -right-28">
          <img src={HeroGuy} alt="the guy" className='w-auto h-[250px]' />
        </div>

        <div className="relative">
          <h1 className='text-primary text-lg font-bold mb-2 pl-6'>
            Everyday info has never <br />been closer
          </h1>

          <div className="flex w-11/12 bg-gradient-to-br from-white/60 rounded-2xl px-5 py-2 backdrop-blur-lg shadow-xl border border-white/30">
            <p className='text-primary text-sm'>
              { SERVICE_SUMMARY[serviceName] }
            </p>
          </div>
        </div>
      </div>


      <h1>Discover</h1>
      <div className='grid grid-cols-2 gap-4 pb-8'>
        {isLoading && <>loading...</>}
        {data && data.map((keyword) => (
          <NavLink 
            key={keyword.slug} 
            className='w-full pb-[100%] relative'
            to={`/${keyword.slug}`}
          >
            <div className='absolute w-full h-full rounded-lg overflow-hidden bg-contain bg-slate-50' style={{backgroundImage: `url(${keyword.image})`}}>
              <div className='absolute bottom-0 h-1/2 w-full bg-gradient-to-t from-black'></div>
              <div className='absolute bottom-0 p-4'>
                <span className='text-white'>{keyword.name}</span>
              </div>
            </div>
          </NavLink>
        ))}
      </div>
    </div>
  )
}

export default Keywords